/**
 * Returns the frame count for webp images, or null for non-webp images
 */
export function getWebpFrameCount(image: Uint8Array): number | null {
  const decoder = new TextDecoder('utf-8');
  const animatedThumbnailBase64String = decoder.decode(image);

  // Check if the string contains "WEBP" to verify it's a webp image
  if (!animatedThumbnailBase64String.includes('WEBP')) {
    return null;
  }

  // Each "ANMF" occurence in the string represents a frame, if no "ANMF" found, it means it's static image.
  const frameCount = (animatedThumbnailBase64String.match(/ANMF/g) || []).length || 1;
  return frameCount;
}

export async function getImageDimension(image: Uint8Array): Promise<{ width: number; height: number }> {
  return new Promise((resolve) => {
    const dataUrlReader = new FileReader();
    dataUrlReader.onload = function (e) {
      const image = new Image();
      // @ts-expect-error
      image.src = e.target.result as string;

      image.onload = () => {
        const width = image.width;
        const height = image.height;

        resolve({ width, height });
      };
    };
    dataUrlReader.readAsDataURL(new Blob([image]));
  });
}
